import { useState, useCallback, useEffect } from 'react';
export const usePinchZoom = ({ size, setSize, isMaximized, isMobile })=>{
    const [isPinching, setIsPinching] = useState(false);
    const [initialPinchDistance, setInitialPinchDistance] = useState(null);
    const [initialSize, setInitialSize] = useState({
        width: 0,
        height: 0
    });
    // 핀치줌 거리 계산
    const getTouchDistance = useCallback((touches)=>{
        const dx = touches[0].clientX - touches[1].clientX;
        const dy = touches[0].clientY - touches[1].clientY;
        return Math.sqrt(dx * dx + dy * dy);
    }, []);
    // 핀치 시작
    const handlePinchStart = useCallback((e)=>{
        if (isMaximized || isMobile || e.touches.length !== 2) return;
        const distance = getTouchDistance(e.touches);
        setInitialPinchDistance(distance);
        setInitialSize({
            width: size.width,
            height: size.height
        });
        setIsPinching(true);
    }, [
        size,
        isMaximized,
        isMobile,
        getTouchDistance
    ]);
    // 핀치 처리
    useEffect(()=>{
        const handleTouchMove = (e)=>{
            if (isMaximized || isMobile) return;
            if (e.touches.length === 2 && isPinching && initialPinchDistance !== null) {
                const currentDistance = getTouchDistance(e.touches);
                const scale = Math.max(0.5, Math.min(currentDistance / initialPinchDistance, 2.5));
                const newWidth = Math.max(300, Math.min(initialSize.width * scale, window.innerWidth - 20));
                const newHeight = Math.max(250, Math.min(initialSize.height * scale, window.innerHeight - 20));
                setSize({
                    width: newWidth,
                    height: newHeight
                });
            }
        };
        const handleTouchEnd = ()=>{
            setIsPinching(false);
            setInitialPinchDistance(null);
        };
        if (isPinching) {
            document.addEventListener('touchmove', handleTouchMove, {
                passive: false
            });
            document.addEventListener('touchend', handleTouchEnd);
        }
        return ()=>{
            document.removeEventListener('touchmove', handleTouchMove);
            document.removeEventListener('touchend', handleTouchEnd);
        };
    }, [
        isPinching,
        initialPinchDistance,
        initialSize,
        getTouchDistance,
        isMaximized,
        isMobile,
        setSize
    ]);
    return {
        isPinching,
        handlePinchStart
    };
};
